// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SimilarVehiclesWrapper_wrapper___QTzK"};